export default {
  "connect.title": "扫码绑定 WhatsApp 账号",
  "connect.description": "使用 WhatsApp 扫描当前二维码",

  "connect.guide.title": "如何打开WhatsApp的扫码功能？",
  "connect.guide.1":
    "iOS 用户打开WhatsApp，点击「设置」菜单，选择「已关联的设备」；Android 用户点击「聊天」菜单，点击右上角「更多」图标，选择「已关联的设备」",
  "connect.guide.2": "进入连接设备页面，点击底部「连接设备」按钮",
  "connect.guide.3": "点击「OK」，开始扫码",

  "connected.title": "绑定成功",
  "connected.description": "你可以打开 12Times App 开始使用",
};
